import initOrderForm from '@/pages/shared/orderForm';
import initSliderCards from '@/pages/shared/sliderCards';
import { OrderFormContent } from '@/components/Forms/OrderForm';

import initSliderPost from './slider';

interface PostConfig {
  slider: string;
  related?: string | null;
  relatedCount?: number;
  orderSource?: string;
  content?: { order: OrderFormContent };
}

export default ({
  slider,
  related,
  relatedCount,
  orderSource,
  content
}: PostConfig): void => {
  initSliderPost(slider);

  if (related) {
    initSliderCards(related, relatedCount ?? 0);
  }

  if (content?.order) {
    initOrderForm({
      content: content.order,
      source: orderSource,
      gaLabel: 'blog-order-submit'
    });
  }
};
